import axios, { AxiosInstance } from 'axios';

// rest of parametars are set in auth provider since we pass api_key and env as prop
export const EXPRESS_API: AxiosInstance = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});
